import React, { useEffect, useState } from "react";
import { Hero } from "./Hero";
import { BrandsSection } from "./BrandsSection";
import { VisionSection } from "./VisionSection";
import { ProductsSection } from "./ProductsSection";


import InputDesign from "./Sections/InputDesign";
import { MapSection } from "./MapSection";
import { setSelected } from "../store/reducers/CartReducer";
import { useDispatch, useSelector } from "react-redux";



export const Home = ({lang, theme}) => {

  const dispatch = useDispatch()
  useEffect(() => {
  dispatch( setSelected({select:0}))
}, []);





const [width, setWidth] = useState(window.innerWidth);
  
useEffect(() => {
  const handleResize = () => setWidth(window.innerWidth);
  window.addEventListener("resize", handleResize);
//  console.log(window.innerWidth);
  return () => window.removeEventListener("resize", handleResize);
  

}, []);

  return (
    <>
  
      
        <Hero  />
        <BrandsSection   />
        {/*<VisionSection lang={lang} />
        <InputDesign  />*/}
        <ProductsSection  />
        {<MapSection  />}
      
    </>
  );
}